/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {addSyncEntityForAccountHolder} from '../api'

export const useMutationAddSyncEntityForAccountHolder = createReactQueryMutationHook('addSyncEntityForAccountHolder', addSyncEntityForAccountHolder)
